<template>
	<div class="center">
		<img
			src="@/assets/roundupapp_logo.png"
			v-bind:style="{
				width: '200px',
				height: 'auto',
				marginTop: '25px',
				marginBottom: '15px',
				marginLeft: 'auto',
				marginRight: 'auto'
			}"
		/>
		<p v-bind:style="{ marginTop: '-5px', fontSize: '8px' }">
			© 2017-2021 Flourish Change Inc. All Rights Reserved
		</p>
	</div>
</template>

<script>
export default {
	name: 'logo'
}
</script>

<style lang="scss">
.center {
	display: flex;
	flex-direction: column;
	align-content: center;
	justify-content: center;
	text-align: center;
}
</style>
